module.exports = __webpack_public_path__ + "static/media/blackArrowDown.6847ffa5.svg";